import React from "react"
import "./hero.scss"

export default function Hero() {
  return (
    <div className="home-hero">
      <div className="hero-title">
        <div className="hero-main-title">Blockchains Connected</div>
        <div className="hero-sub-title">
          Every dApp, Every Asset, Every User
        </div>
      </div>
    </div>
  )
}
